import logo from "../../../imgs/TuViajeLogo.png";
import { NavLink } from "react-router-dom";
import { SubMenu } from "./SubMenu";
import { navigation } from "./nav";
import "./style.css";

export const NavBar = () => {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className="navbar bg-dark border-bottom border-body navbar-expand-lg bg-body-tertiary" data-bs-theme="dark">
      <div className="container-fluid">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            {navigation.map((item, index) => (
              <li className="nav-item" key={index}>
                <NavLink
                  to={item.link + (item.target ? `#${item.target}` : '')}
                  className="nav-link"
                  onClick={() => {
                    if (item.target) handleScroll(item.target);
                  }}
                >
                  {item.name}
                </NavLink>
              </li>
            ))}

            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                <ion-icon name="person-outline" className="user_login"></ion-icon>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <SubMenu />
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
